import { FormularioItem } from './formulario-item.model';
import { Usuario } from './usuario.model';

export class Formulario {

    id: number;
    nombre: string;
    tipo: string;
    descripcion: string;
    sentencias: FormularioItem[];
    creador: Usuario;
    fechaCreado: Date;
    estado: string;

    /**
     * Constructor
     *
     * @param formulario
     */
    constructor(formulario)
    {
        {
            this.id = formulario.id || null;
            this.nombre = formulario.nombre || '';
            this.tipo = formulario.tipo || 'SIMPLIFICADA_Y_AMPLIADA';
            this.estado = formulario.estado || 'INICIADO';
            this.descripcion = formulario.descripcion || '';
            this.sentencias = formulario.sentencias || [];

        }
    }
}
